import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';
import { User } from 'src/app/store/Authentication/auth.models';
import { BehaviorSubject, from } from 'rxjs';
import {map, startWith} from 'rxjs/operators'; 
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;

    private currentUserSubject: BehaviorSubject<User>;
  
  
  
  
    public get currentUserValue(): User {
      return this.currentUserSubject.value;
  }
 

    constructor(private http: HttpClient,private router: Router,) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    //    this.currentUser = this.currentUserSubject.asObservable();
    }

    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }


    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        return from(getFirebaseBackend().loginUser(email, password).pipe(map(user => {
            return user;
        }
        )));
    }



    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(user: User) {
        // return from(getFirebaseBackend().registerUser(user));

        return from(getFirebaseBackend().registerUser(user).then((response: any) => {
            const user = response;
            return user;
        }));
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(email: string) {
        return getFirebaseBackend().forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        });
    }

    /**
     * Logout the user
     */
    logout() {

        this.clearCookies();
        this.clearCache();
    
        this.router.navigate(['/auth/login']);
          
      }
    
      clearCookies(){
        localStorage.removeItem('twoFactorToken');
        localStorage.removeItem('codeExpire');
        localStorage.removeItem('isSessionActive');
        localStorage.removeItem('attempsRemaining');
        localStorage.removeItem('codeSendSuccess');
        localStorage.removeItem('user_id');
        localStorage.removeItem('currentUser');
        
    
      }
    
      clearCache(){
        //this.profileDetails$=null;
        
    
    
      }
}

